module.exports = __webpack_public_path__ + "static/media/gallery-addBlack.9ae510b6.svg";